import React, { useState, useEffect, useContext } from 'react'
import { Container, Row, Col, ListGroup, Button, Form, InputGroup } from 'react-bootstrap'
import { useParams, Redirect, useHistory } from 'react-router-dom'
import { FirebaseContext } from '../firebase'
import ArticleListItem from '../components/ArticleListItem'
import useFormValidation from '../auth/useFormValidation'
import validateCreateLink from '../auth/validateCreateLink'
import axios from 'axios'
import Reorder, { reorder } from 'react-reorder'
import firebase from 'firebase'
import { LinkContainer } from 'react-router-bootstrap'
import { RIEInput } from 'riek'
import _ from 'lodash'

const INITIAL_STATE = {
    url: ""
}

function Edit(props) {

    const { sequenceId } = useParams()
    const { fire, user } = useContext(FirebaseContext)
    const history = useHistory()
    const [articles, setArticles] = useState([])
    const [sequence, setSequence] = useState("")
    const [confirmDelete, setConfirmDelete] = useState(false)
    const { handleChange, handleSubmit, values, errors, isSubmitting } = useFormValidation(INITIAL_STATE, validateCreateLink)

    useEffect(() => {
        getSequence()
    }, [])

    useEffect(() => {
        getArticles()
    }, [sequence])

    function getSequence() {
        fire.firestore().collection('sequences').doc(sequenceId)
            .onSnapshot((doc) => {
                if (doc.exists) {
                    setSequence({
                        id: doc.id,
                        ...doc.data()
                    })
                } else {
                    console.log("Couldn't find Sequence by ID")
                }
            })
    }

    function getArticles() {
        fire.firestore().collection('articles').where('sequence', "==", sequenceId).onSnapshot(handleSnapshot)
    }

    function handleSnapshot(snapshot) {
        const articles = snapshot.docs.map(doc => {
            return {
                id: doc.id,
                ...doc.data()
            }
        })
        const sortingArray = sequence.articles
        if (sortingArray) {
            setArticles(articles.sort((a, b) => {
                return sortingArray.indexOf(a.id) - sortingArray.indexOf(b.id)
            }))
        }
    }

    function onSubmit(event) {
        event.preventDefault()
        const data = {
            'url': values.url,
            'sequence': sequenceId,
            'title': "Loading...",
            'created': Date.now()
        }
        fire.firestore().collection('articles').add(data)
            .then(docRef => {
                axios.get(`https://us-central1-react-sequences.cloudfunctions.net/getTitle?articleId=${docRef.id}&url=${encodeURIComponent(values.url)}`)
                // axios.get(`http://localhost:5001/react-sequences/us-central1/getTitle?articleId=${docRef.id}&url=${encodeURIComponent(values.url)}`)
                    .then(resp => {
                        console.log(resp.data)
                        fire.firestore().collection('sequences').doc(sequenceId)
                            .update({
                                'articles': firebase.firestore.FieldValue.arrayUnion(docRef.id)
                            })
                    })
            }).catch(err => console.log(err))
        values.url = ""
    }

    function onReorder(event, previousIndex, nextIndex, fromId, toId) {
        const reorderedArticles = reorder(articles, previousIndex, nextIndex)
        fire.firestore().collection('sequences').doc(sequenceId)
            .update({
                'articles': reorderedArticles.map(a => a.id)
            })
    }

    function handleDelete() {
        if (!confirmDelete) {
            setConfirmDelete(true)
        } else {
            deleteSequence()
            history.push("/profile")
        }
    }

    function deleteSequence() {
        fire.firestore().collection('sequences').doc(sequenceId).delete()
    }

    function handlePublish() {
        fire.firestore().collection('sequences').doc(sequenceId)
            .update({
                published: true
            })
    }

    function handleUnpublish() {
        fire.firestore().collection('sequences').doc(sequenceId)
            .update({
                published: false
            })
    }

    function handleRename(p) {
        fire.firestore().collection('sequences').doc(sequenceId)
            .update({
                name: p.name
            })
    }

    function changeCover() {
        const randomNum = Math.floor(Math.random() * 1000)
        fire.firestore().collection('sequences').doc(sequenceId)
            .update({
                img: `https://gradienthunt.com/gradients-images/${randomNum}.jpg`
            })
    }

    const articleComponents = articles.map(article => <div key={article.id}><ArticleListItem article={article} sequenceId={sequenceId} /></div>)

    if (user && sequence.createdBy) {
        if (user.uid === sequence.createdBy) {
            return (
                <div>
                    <header
                        className="sequence-cover position-relative"
                        style={{ backgroundImage: `url(${sequence.img})`, backgroundSize: 'cover' }}>
                        <Container style={{ height: '300px' }}>
                            <Row className="h-100 align-items-center justify-content-center">
                                <Col md={{ span: 10 }} className="text-center sequence-cover-textbox">
                                    <h6>SEQUENCE</h6>
                                    <h1 className="text-break">
                                        <RIEInput
                                            value={sequence.name}
                                            change={handleRename}
                                            propName='name'
                                            validate={_.isString}
                                            editProps={{
                                                maxLength: 50
                                            }} />
                                    </h1>
                                </Col>
                            </Row>
                            <Button onClick={changeCover} variant="light" size="sm" className="position-absolute" style={{ bottom: 10, right: 10 }}>Change cover</Button>
                        </Container>
                    </header>
                    <Container className="mb-2">
                        <Row>
                            <Col md={{ span: 8, offset: 2 }}>
                                <Form onSubmit={e => handleSubmit(e, onSubmit)} className="mt-3">
                                    <InputGroup size="md">
                                        <Form.Control
                                            type="url"
                                            placeholder="Add a link..."
                                            autoComplete="off"
                                            onChange={handleChange}
                                            name="url"
                                            className={errors.url && 'error-input'}
                                            value={values.url} />
                                        <InputGroup.Append>
                                            <Button variant="primary" type="submit" disabled={isSubmitting}>Add to sequence</Button>
                                        </InputGroup.Append>
                                    </InputGroup>
                                    {errors.url && <p className="error-text">{errors.url}</p>}
                                </Form>
                                <ListGroup className="mt-3 mb-2 pl-4 pr-4">
                                    <Reorder
                                        reorderId={sequenceId} // Unique ID that is used internally to track this list (required)
                                        onReorder={onReorder.bind(this)} // Callback when an item is dropped (you will need this to update your state)
                                        touchHoldTime={200} // Hold time before dragging begins on touch devices (optional), defaults to holdTime    
                                    >
                                        {articleComponents}
                                    </Reorder>
                                </ListGroup>
                                {sequence.published ?
                                    <Button onClick={handleUnpublish} variant="secondary" className="mr-1">Unpublish Sequence</Button>
                                    : <Button onClick={handlePublish} variant="success" className="mr-1">Publish Sequence</Button>
                                }
                                <LinkContainer to={`/sequence/${sequenceId}`}>
                                    <Button variant="info" className="mr-1">{sequence.published ? 'View' : 'Preview'}</Button>
                                </LinkContainer>
                                <Button onClick={handleDelete} variant="outline-danger" className="mr-1">{confirmDelete ? "Really delete?" : "Delete"}</Button>
                            </Col>
                        </Row>
                    </Container>
                </div>
            )
        } else {
            return <Redirect to="/login" />
        }
    } else if (sequence.createdBy) {
        return <Redirect to="/login" />
    } else {
        return null
    }
}

export default Edit